import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function EmailConfirmed() {
	const [searchParams] = useSearchParams();
	const status = searchParams.get("status") || "success";
	const isSuccess = status === "success";

	useEffect(() => {
		if (isSuccess) {
			window.location.href = "gymnote://email-confirme";
		}
	}, [isSuccess]);

	return (
		<div style={containerStyle}>
			<div style={{ ...iconStyle, color: isSuccess ? "#30a49a" : "#e57373" }}>
				{isSuccess ? "✓" : "!"}
			</div>
			<h2 style={{ ...titleStyle, color: isSuccess ? "#30a49a" : "#e57373" }}>
				{isSuccess ? "Email confirmé" : "Lien expiré"}
			</h2>
			<p style={textStyle}>
				{isSuccess
					? "Ton compte GymNote est maintenant actif."
					: "Ce lien de confirmation n'est plus valide, ou a déjà été utilisé."}
			</p>
			<p style={{ ...textStyle, marginBottom: 30 }}>
				{isSuccess
					? "Ouvre l'application GymNote pour te connecter."
					: "Si tu es déjà connecté à l'app, tout est bon. Sinon, demande un nouveau lien depuis l'écran d'inscription."}
			</p>
			<div style={storeContainer}>
				<a
					href="https://apps.apple.com/fr/app/gymnote-suivi-muscu-coach/id6470710692"
					style={storeLinkStyle}
				>
					Télécharger sur App Store
				</a>
				<a
					href="https://play.google.com/store/apps/details?id=com.frenchmatrix.GymNote"
					style={storeLinkStyle}
				>
					Télécharger sur Google Play
				</a>
			</div>
		</div>
	);
}

const containerStyle = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	minHeight: "60vh",
	padding: "20px",
	textAlign: "center",
};

const iconStyle = {
	fontSize: "64px",
	fontWeight: "bold",
	lineHeight: 1,
	marginBottom: "10px",
	border: "3px solid",
	borderRadius: "50%",
	width: "90px",
	height: "90px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

const titleStyle = {
	fontSize: "28px",
	marginBottom: "15px",
};

const textStyle = {
	color: "#ccc",
	fontSize: "16px",
	marginBottom: "10px",
	maxWidth: "460px",
};

const storeContainer = {
	display: "flex",
	flexDirection: "column",
	gap: "12px",
};

const storeLinkStyle = {
	color: "#fff",
	background: "#30a49a",
	padding: "12px 24px",
	borderRadius: "8px",
	textDecoration: "none",
	fontSize: "16px",
};

export default EmailConfirmed;
